import { AnimatePresence } from 'framer-motion';
import { MouseEventHandler } from 'react';
import { H3, lightTheme, modalVariants } from '../../styles';
import {
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalScrollableStyled,
  ModalStyled,
  ModalWrapper,
} from './modalFullscreen.styled';
import { XModalIcon } from '../../assets';

export const ModalFullScreen = ({
  children,
  height,
  isOpen,
  closeModal,
  exitButton = true,
  header,
  width,
  footer,
  zIndex,
  backgroundColor,
  $numOfFloatingButtons,
}: {
  children: React.ReactNode;
  height?: string;
  isOpen: boolean;
  closeModal?: () => void;
  exitButton?: boolean;
  header?: string;
  width?: string | number;
  footer?: React.ReactNode;
  zIndex?: number;
  $numOfFloatingButtons?: number;
  backgroundColor?: string;
}) => {
  const handleParentClick: MouseEventHandler<HTMLDivElement> = (event) => {
    if (event.target === event.currentTarget) {
      closeModal?.();
    }
  };

  return (
    <AnimatePresence mode="wait">
      {isOpen && (
        <ModalWrapper onClick={handleParentClick} $zIndex={zIndex}>
          <ModalStyled
            key="modal"
            variants={modalVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            $width={width}
            $zIndex={zIndex}
            $backgroundColor={backgroundColor}
          >
            {header && (
              <ModalHeader>
                <H3 $m="0" $color={lightTheme.white}>
                  {header}
                </H3>
              </ModalHeader>
            )}

            {footer && (
              <ModalFooter $numOfFloatingButtons={$numOfFloatingButtons}>
                {footer}
              </ModalFooter>
            )}

            <ModalScrollableStyled
              $footer={!!footer}
              $numOfFloatingButtons={$numOfFloatingButtons}
              $height={height}
            >
              {children}
            </ModalScrollableStyled>

            {exitButton && (
              <div
                onClick={() => closeModal?.()}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  cursor: 'pointer',
                }}
              >
                <XModalIcon
                  color={header ? lightTheme.white : lightTheme.lightGray}
                />
              </div>
            )}
          </ModalStyled>
        </ModalWrapper>
      )}
      {isOpen && (
        <ModalOverlay
          key="modalOverlay"
          variants={modalVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          $zIndex={zIndex}
        ></ModalOverlay>
      )}
    </AnimatePresence>
  );
};
